import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import './company/CompanySignUp.css';
import { Grid } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';
import { connect } from 'react-redux';
import { withFirebase, isEmpty, isLoaded } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import { saveProfilePictureUrl } from '../../store/actions/companyActions';
import { omit } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCity } from '@fortawesome/free-solid-svg-icons';

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveUrl: url => dispatch(saveProfilePictureUrl(url))
  };
};

const styles = theme => ({
  upload: {
    width: 'fit-content',
    textAlign: 'center',
    marginTop: '40px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  circleImage: {
    marginTop: '40px',
    objectFit: 'cover',
    borderRadius: '50%',
    width: '120px',
    height: '120px',
    border: 'solid 2px lightgray'
  }
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),

  // Add props.firebase (used in handlers)
  withFirebase,

  // Add custom props
  withProps(({ auth, profile }) => ({
    authExists: isLoaded(auth) && !isEmpty(auth),
    auth,
    profile
  })),
  withStyles(styles)
);

function ProfilePictureUpload(props) {
  const { firebase, saveUrl, profile, classes } = props;

  const onDropAccepted = useCallback(acceptedFile => {
    var user = firebase.auth().currentUser;
    const filePath = `${user.uid}/profilePicture`;

    const options = {
      metadataFactory: uploadRes => {
        const { metadata } = uploadRes;
        const cleanMeta = omit(metadata, [
          'cacheControl',
          'contentLanguage',
          'customMetadata'
        ]);
        return cleanMeta;
      }
    };

    firebase
      .uploadFiles(filePath, acceptedFile, filePath, options)
      .then(file => {
        file[0].uploadTaskSnapshot.ref.getDownloadURL().then(downloadUrl => {
          saveUrl(downloadUrl);
        });
      });
  }, []);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: 'image/jpeg, image/png',
    onDropAccepted: onDropAccepted
  });

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <React.Fragment>
      <Grid
        container
        direction="column"
        spacing={24}
        align="center"
        justify="center"
      >
        {profile.profilePictureUrl && (
          <img
            src={profile.profilePictureUrl}
            className={classes.circleImage}
          />
        )}

        <section className={`${classes.upload} "file-upload-container"`}>
          <div
            {...getRootProps({ className: 'dropzone' })}
            className="dropzone-container"
          >
            <input {...getInputProps()} />
            <Button variant="outlined" color="primary" align="center">
              Upload
            </Button>
          </div>
        </section>
      </Grid>
    </React.Fragment>
  );
}

ProfilePictureUpload.propTypes = {
  classes: PropTypes.object.isRequired,
  saveUrl: PropTypes.func,
  profile: PropTypes.object.isRequired
};

export default enhance(ProfilePictureUpload);



// WEBPACK FOOTER //
// ./src/components/sign-up/ProfilePictureUpload.js